import { createAction, props } from '@ngrx/store';
import { Organization } from '../models/organization.model';
import { UserOrganization, UserProfile } from './user-profile.model';
import { Language } from '../../languages/language.model';
import { OrgBusinessUnit } from '../../org-business-units';

export const setProfileError = createAction('[UserProfile/API] Set Profile Error', props<{ err: any }>());
export const setConnection = createAction('[UserProfile/API] Set Profile Connection', props<{ profileConnection: string }>());
export const setIsProfileSubmitting = createAction(
  '[UserProfile/Page] Set isProfileSubmitting state',
  props<{ isProfileSubmitting: boolean }>()
);

export const showProfileForm = createAction('[UserProfile/Page] Show User Profile', props<{ showProfileForm: boolean }>());
export const showPasswordForm = createAction('[UserProfile/Page] Show Password Change Form', props<{ showPasswordForm: boolean }>());

export const getUserProfile = createAction('[UserProfile/API] Get User Profile');
export const getUserProfileComplete = createAction('[UserProfile/API] Load User Profile', props<{ result: UserProfile }>());
export const saveUserProfile = createAction('[UserProfile/Page] Save User Profile', props<{ userProfile: UserProfile; close: boolean }>());
export const getUserOrganizations = createAction('[UserProfile/API] Get User Organizations');
export const getUserOrganizationsComplete = createAction(
  '[UserProfile/API] Load User Organizations',
  props<{ userOrganizations: UserOrganization[] }>()
);
export const getUserOrganization = createAction('[UserProfile/API] Get User Organization');
export const getUserOrganizationComplete = createAction(
  '[UserProfile/API] Set User Organization',
  props<{ userOrganization: Organization }>()
);

export const getUserBusinessUnits = createAction('[UserProfile/API] Get User BusinessUnits');
export const getUserBusinessUnitsComplete = createAction(
  '[UserProfile/API] Load User BusinessUnits',
  props<{ businessUnits: OrgBusinessUnit[] }>()
);

export const profileLogout = createAction('[UserProfile/API] Logout Profile');
export const changePassword = createAction('[UserProfile/Page] Change Profile Password', props<{ oldPass: string; newPass: string }>());

export const getUserOrganizationLanguages = createAction('[UserProfile/API] Load Organization Languages');
export const getUserOrganizationLanguagesComplete = createAction(
  '[UserProfile/API] Load Organization Languages Complete',
  props<{ languages: Language[] }>()
);

export const changeAppLanguage = createAction('[UserProfile/Page] Change language of the app', props<{ cultureCode: string }>());

export const changeTranslationCulture = createAction('[UserProfile/Page] Change Translation culture', props<{ cultureCode: string }>());

export const useTranslationCulture = createAction('[UserProfile/Page] Use Translation culture', props<{ cultureCode: string }>());

export const showNotificationPreferences = createAction('[UserProfile/Page] Show Notification Preferences');

export const showNotificationPreferencesComplete = createAction('[UserProfile/Page] Show Notification Preferences Complete');
